import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ClusterInterface } from '../../common/types/types'

const initialState: { cluster: ClusterInterface | undefined } = {
  cluster: undefined,
}

export const currentClusterSlice = createSlice({
  name: 'current-cluster',
  initialState,
  reducers: {
    setCurrentCluster: (state, action: PayloadAction<ClusterInterface | undefined>) => {
      state.cluster = action.payload ? { ...action.payload } : undefined
    },
    resetCurrentCluster: (state) => {
      state.cluster = undefined
    },
  },
})

export const { setCurrentCluster, resetCurrentCluster } = currentClusterSlice.actions

export const selectCurrentCluster = (state: RootState) => state.currentCluster.cluster

export default currentClusterSlice.reducer
